import NavigationProvider from ':cloud/contexts/NavigationProvider';
import NavigationProviderDEPRECATED from ':cloud/contexts/NavigationProvider_DEPRECATED';

type ConditionalNavigationProviderProps = {
  useDeprecated: boolean;
  children: JSX.Element[] | JSX.Element;
};
export function ConditionalNavigationProvider({
  useDeprecated,
  children,
}: ConditionalNavigationProviderProps) {
  if (useDeprecated) {
    return <NavigationProviderDEPRECATED>{children}</NavigationProviderDEPRECATED>;
  }
  return <NavigationProvider>{children}</NavigationProvider>;
}
